import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Result, Button, Space } from 'antd';

export default function NotFound({ loggedInUser, onLogout }) {
  const navigate = useNavigate();

  function handleLogoutAndGoAuth() {
    if (onLogout) onLogout();
    navigate('/auth');
  }

  return (
    <div style={{ padding: 24 }}>
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的页面不存在。"
        extra={<Button type="primary"><Link to="/">返回首页</Link></Button>}
      />
    </div>
  );
}
